import { AreaItem } from '@/types/cms/AreaItem'
import AppContext from '@/types/context'
import Gallery from '@/elements/widgets/Gallery/Gallery'
import styles from './GalleryInlineTop.module.scss'

const GalleryDefault = ({ item, context }: { item: AreaItem; context: AppContext }) => {
  const gallery = item.items?.find((child) => child.type === 'gallery')
  if (!item?.items || !gallery) {
    return
  }

  return (
    <div className={styles.container}>
      <Gallery context={context} item={item} variant="inline-top" />
    </div>
  )
}

export default GalleryDefault
